var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-warning btn-block",on:{"click":function($event){return _vm.onTaminClicked(_vm.row.product.id)}}},[_vm._v("تامین")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }